import type { MiniUser } from './user';

export enum FollowRequestStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected',
}

export interface FollowRequest {
  status: FollowRequestStatus;
  user: MiniUser;
}
